import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import RegisterPageViewModel from './RegisterPageViewModel.type';

type RegisterPageType = RegisterPageViewModel & PageType;

export default (currentPage: PageType): currentPage is RegisterPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Account_Register_RegisterPageViewModel;
};
